import { useContext, useCallback, useMemo } from 'react';
import { ModalHistoryContext } from '../History/History.js';
import { events } from '../events.js';

/**
 * Modal Hook.
 */ function useModal() {
    const { push, back, clear, route, prevRoute, replace } = useContext(ModalHistoryContext);
    /**
     * Close modal.
     */ const close = useCallback((event)=>{
        // emit close start event
        void events.emit('onCloseStart', event).finally(()=>{
            // clear history
            clear();
        });
    }, [
        clear
    ]);
    const router = useMemo(()=>({
            push,
            back,
            replace,
            clear
        }), [
        back,
        clear,
        push,
        replace
    ]);
    const history = useMemo(()=>({
            route,
            prevRoute,
            query: route?.query ?? {}
        }), [
        prevRoute,
        route
    ]);
    return {
        router,
        history,
        events,
        close
    };
}

export { useModal };
//# sourceMappingURL=useModal.js.map
